import script from "./ViewAddNewUsers.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewAddNewUsers.vue?vue&type=script&setup=true&lang=js"

import "./ViewAddNewUsers.vue?vue&type=style&index=0&id=952ae61a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-952ae61a"]])

export default __exports__